(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3july-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Also bail if ANY predictive-search is open (covers both desktop & mobile)
      const anySearchOpen = document.querySelector('predictive-search[open]');
      if (anySearchOpen) return;

      // Also bail if the mobile search modal is active
      if (document.querySelector('.header__desktop__bar__r.mobile.search-modal-active')) return;

      // Also bail if body scroll is locked by search
      if (document.body.classList.contains('overflow-hidden')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hair-diagnosis-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(sectionId) {
    var slides = document.querySelectorAll('#hd-slides-' + sectionId + ' .hd-hero__slide');
    var dots = document.querySelectorAll('[data-carousel="' + sectionId + '"][data-index]');
    var navBtns = document.querySelectorAll('[data-carousel="' + sectionId + '"][data-dir]');
    if (!slides.length) return;
    var current = 0;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      dots[current] && dots[current].setAttribute('aria-selected', 'false');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
      dots[current] && dots[current].setAttribute('aria-selected', 'true');
    }

    navBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(current + parseInt(btn.dataset.dir));
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index));
      });
    });
  }

  document.querySelectorAll('.hd-hero__carousel').forEach(function (el) {
    initCarousel(el.id.replace('hd-carousel-', ''));
  });

  // Modal + step flow
  (function () {
    var modal = document.getElementById('hd-test-modal');
    if (!modal) return;
    var lastFocus = null;
    // ── Google Sheets endpoint — replace with your deployed Apps Script URL ──
    // ⚠️ Paste your Apps Script /exec URL here (NOT the Google Sheets URL)
    // Get it: Extensions → Apps Script → Deploy → New deployment → Web app → copy the /exec URL
    var HD_SHEETS_URL = 'https://script.google.com/macros/s/AKfycbzcOdRlszbwsHUB-UVWQLg9ZSie7rCYnewnJNyQhtwIBvV5GH13P_zJqMekQJ9hnDS5Wg/exec';

    var hdUser = { name: '', email: '', age: '', sex: '', mobile: '' };

    function goToStep(stepId) {
      modal.querySelectorAll('.hd-modal__step').forEach(function (s) {
        s.style.display = 'none';
      });
      var target = document.getElementById('hd-step-' + stepId);
      if (target) {
        target.style.display = 'flex';
        target.scrollTop = 0;
      }
    }

    // Enforce numeric-only input on the mobile number field
    var mobileField = document.getElementById('hd-ui-mobile');
    if (mobileField) {
      mobileField.addEventListener('input', function () {
        var pos = this.selectionStart;
        var cleaned = this.value.replace(/\D/g, '');
        if (this.value !== cleaned) {
          this.value = cleaned;
          // Restore caret position after stripping non-digits
          this.setSelectionRange(pos - 1 > 0 ? pos - 1 : 0, pos - 1 > 0 ? pos - 1 : 0);
        }
      });
      mobileField.addEventListener('keydown', function (e) {
        // Allow: backspace, delete, tab, escape, enter, arrows, home, end
        var allowed = [8, 9, 13, 27, 35, 36, 37, 38, 39, 40, 46];
        if (allowed.indexOf(e.keyCode) !== -1) return;
        // Allow Ctrl/Cmd+A, C, V, X
        if ((e.ctrlKey || e.metaKey) && [65, 67, 86, 88].indexOf(e.keyCode) !== -1) return;
        // Block anything that isn't a digit (0–9)
        if (e.key < '0' || e.key > '9') e.preventDefault();
      });
    }

    function openModal() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      goToStep('intro');
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    function resetForm() {
      // Reset user state
      hdUser = { name: '', email: '', age: '', sex: '', mobile: '' };
      hdSubmitting = false;

      // Clear all text inputs
      modal.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"]').forEach(function (i) {
        i.value = '';
        i.classList.remove('is-error');
      });

      // Clear hidden age input
      var ageInput = document.getElementById('hd-ui-age');
      if (ageInput) ageInput.value = '';

      // Deselect all tiles, chips, radios
      modal.querySelectorAll('.is-selected').forEach(function (el) {
        el.classList.remove('is-selected');
      });

      // Clear file inputs and photo previews
      modal.querySelectorAll('.hd-q14__file-input').forEach(function (inp) {
        inp.value = '';
      });
      modal.querySelectorAll('[data-preview]').forEach(function (p) {
        p.innerHTML = '';
        p.style.backgroundImage = '';
      });
      modal.querySelectorAll('.hd-q14__slot').forEach(function (s) {
        s.classList.remove('has-photo');
      });

      // Hide all validation error messages
      modal.querySelectorAll('.hd-quest__val-msg').forEach(function (m) {
        m.style.display = 'none';
      });
    }

    function hasAnyData() {
      // Check if user has entered anything meaningful
      var name   = document.getElementById('hd-ui-name');
      var mobile = document.getElementById('hd-ui-mobile');
      if (name && name.value.trim()) return true;
      if (mobile && mobile.value.trim()) return true;
      // Check any question selection
      if (document.querySelector('.hd-modal__step [data-hd-tile].is-selected')) return true;
      if (document.querySelector('.hd-modal__step [data-hd-radio].is-selected')) return true;
      if (document.querySelector('.hd-modal__step [data-hd-chip].is-selected')) return true;
      if (document.querySelector('.hd-modal__step [data-hd-chip-single].is-selected')) return true;
      return false;
    }

    function submitAndClose() {
      if (!hasAnyData() || hdSubmitting) {
        closeModal();
        return;
      }
      // Submit silently in background — don't block close or show spinner
      if (HD_SHEETS_URL && HD_SHEETS_URL.indexOf('PASTE_') !== 0) {
        readPhotosAsBase64(function (photos) {
          var payload = {
            name: hdUser.name, email: hdUser.email, phone: hdUser.mobile,
            age: hdUser.age, gender: hdUser.sex,
            q1:  collectAnswer('q1'),
            q2:  collectAnswer('question'),
            q3:  collectAnswer('q3'),
            q4:  collectAnswer('q4'),
            q5:  collectAnswer('q5'),
            q6:  collectAnswer('q6'),
            q7:  collectAnswer('q7'),
            q8:  collectAnswer('q8'),
            q9:  collectAnswer('q9'),
            q10: collectAnswer('q10'),
            q11: collectAnswer('q11'),
            q12: collectAnswer('q12'),
            q13: collectAnswer('q13'),
            partial: true,
            photos: photos
          };
          fetch(HD_SHEETS_URL, {
            method: 'POST', mode: 'no-cors',
            headers: { 'Content-Type': 'text/plain' },
            body: JSON.stringify(payload)
          }).catch(function () {});
        });
      }
      closeModal();
    }

    function validateUserInfo() {
      var valid = true;
      var nameInput = document.getElementById('hd-ui-name');
      var emailInput = document.getElementById('hd-ui-email');
      var ageInput = document.getElementById('hd-ui-age');
      var mobileInput = document.getElementById('hd-ui-mobile');
      var mobileWrap = document.getElementById('hd-ui-mobile-wrap');

      // Name
      var nameErr = document.getElementById('hd-ui-name-err');
      nameInput.classList.remove('is-error');
      nameErr.textContent = '';
      if (!nameInput.value.trim()) {
        nameInput.classList.add('is-error');
        nameErr.textContent = 'Please enter your name.';
        valid = false;
      }

      // Email — optional; only validate format if user typed something
      var emailErr = document.getElementById('hd-ui-email-err');
      if (emailInput && emailErr) {
        emailInput.classList.remove('is-error');
        emailErr.textContent = '';
        var emailVal = emailInput.value.trim();
        if (emailVal && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
          emailInput.classList.add('is-error');
          emailErr.textContent = 'Please enter a valid email address.';
          valid = false;
        }
      }

      // Age (chip-based hidden input)
      var ageErr = document.getElementById('hd-ui-age-err');
      var ageBtns = document.querySelectorAll('#hd-step-userinfo .hd-userinfo__age-btn');
      ageErr.textContent = '';
      ageBtns.forEach(function (b) { b.classList.remove('is-error'); });
      if (!ageInput.value) {
        ageBtns.forEach(function (b) { b.classList.add('is-error'); });
        ageErr.textContent = 'Please select your age group.';
        valid = false;
      }

      // Sex
      var genderErr = document.getElementById('hd-ui-gender-err');
      var genderBtns = document.querySelectorAll('#hd-step-userinfo .hd-userinfo__gender-btn');
      genderErr.textContent = '';
      genderBtns.forEach(function (b) { b.classList.remove('is-error'); });
      if (!hdUser.sex) {
        genderBtns.forEach(function (b) { b.classList.add('is-error'); });
        genderErr.textContent = 'Please select your gender.';
        valid = false;
      }

      // Mobile — 10 digits
      var mobileErr = document.getElementById('hd-ui-mobile-err');
      mobileWrap.classList.remove('is-error');
      mobileErr.textContent = '';
      var mobileVal = mobileInput.value.replace(/\D/g, '');
      if (mobileVal.length !== 10 || !/^[6-9]/.test(mobileVal)) {
        mobileWrap.classList.add('is-error');
        mobileErr.textContent = mobileVal.length !== 10
          ? 'Please enter a valid 10-digit mobile number.'
          : 'Mobile number must start with 6, 7, 8, or 9.';
        valid = false;
      }

      if (valid) {
        hdUser.name = nameInput.value.trim();
        hdUser.email = emailInput ? emailInput.value.trim() : '';
        hdUser.age = ageInput.value;
        hdUser.mobile = '+91' + mobileVal;
      }

      return valid;
    }

    // ── Collect selected answer text from a step ───────────────────────────
    function collectAnswer(stepId) {
      var step = document.getElementById('hd-step-' + stepId);
      if (!step) return '';

      // Q1 — img-tiles multi-select: collect ALL selected tile labels
      var imgTiles = step.querySelectorAll('.hd-quest__img-tile[data-hd-tile].is-selected');
      if (imgTiles.length > 0) {
        return Array.from(imgTiles).map(function (t) {
          var lbl = t.querySelector('.hd-quest__img-tile-label');
          return lbl ? lbl.textContent.trim() : t.textContent.trim();
        }).join(', ');
      }

      // Regular single-select tiles (Q2, Q9)
      var tile = step.querySelector('.hd-quest__tile[data-hd-tile].is-selected, .hd-q9__tile[data-hd-tile].is-selected');
      if (tile) {
        var lbl = tile.querySelector('.hd-quest__tile-label, .hd-q9__label, p');
        return lbl ? lbl.textContent.trim() : tile.textContent.trim();
      }

      // Q3 — radio (multi-select) + chip-single (when noticed): combine both parts
      var radios = step.querySelectorAll('[data-hd-radio].is-selected');
      if (radios.length > 0) {
        var parts = [];
        var radioAnswers = Array.from(radios).map(function (r) {
          // Query .hd-q3__option-label directly to avoid picking up the empty aria-hidden radio dot span
          var lbl = r.querySelector('.hd-q3__option-label');
          return lbl ? lbl.textContent.trim() : r.textContent.replace(/\s+/g, ' ').trim();
        }).join(', ');
        parts.push('Changed: ' + radioAnswers);
        var singles3 = step.querySelectorAll('[data-hd-chip-single].is-selected');
        if (singles3.length > 0) {
          var singleLbl = singles3[0].querySelector('.hd-q3__option-label') || singles3[0];
          parts.push('When noticed: ' + singleLbl.textContent.trim());
        }
        return parts.join(' | ');
      }

      // Multi-group steps (Q5): collect each role="group" separately then combine
      // Must run BEFORE singles check so Q5's first two groups aren't skipped
      var chipGroups = step.querySelectorAll('[role="group"]');
      if (chipGroups.length > 1) {
        var groupParts = [];
        chipGroups.forEach(function (grp) {
          var multiSel = grp.querySelectorAll('[data-hd-chip].is-selected');
          var singleSel = grp.querySelectorAll('[data-hd-chip-single].is-selected');
          function chipLabel(c) {
            var l = c.querySelector('.hd-q6__label, .hd-q9__label, .hd-q3__option-label');
            return l ? l.textContent.trim() : c.textContent.replace(/\s+/g, ' ').trim();
          }
          if (multiSel.length > 0) {
            groupParts.push(Array.from(multiSel).map(chipLabel).join(', '));
          } else if (singleSel.length > 0) {
            groupParts.push(chipLabel(singleSel[0]));
          }
        });
        if (groupParts.length > 0) return groupParts.join(' | ');
      }

      // Single-select chip-single — single group (Q4 family history)
      var singles = step.querySelectorAll('[data-hd-chip-single].is-selected');
      if (singles.length > 0) {
        var lbl = singles[0].querySelector('.hd-q3__option-label') ||
                  singles[0].querySelector('.hd-q6__label') ||
                  singles[0].querySelector('.hd-q7__title');
        return lbl ? lbl.textContent.trim() : singles[0].textContent.replace(/\s+/g, ' ').trim();
      }

      // Multi-select chips — single group (Q10, Q11, Q12)
      var chips = step.querySelectorAll('[data-hd-chip].is-selected');
      if (chips.length > 0) {
        return Array.from(chips).map(function (c) { return c.textContent.trim(); }).join(', ');
      }

      // Multi-select radio fallback (Q13)
      var radiosAll = step.querySelectorAll('[data-hd-radio].is-selected');
      if (radiosAll.length > 0) {
        return Array.from(radiosAll).map(function (r) {
          var txt = r.querySelector('.hd-q6__label, p');
          return txt ? txt.textContent.trim() : r.textContent.replace(/\s+/g, ' ').trim();
        }).join(', ');
      }

      return '';
    }

    // ── Read photos from Q14 — uses compressed versions where available ───
    function readPhotosAsBase64(callback) {
      var inputs = Array.from(document.querySelectorAll('#hd-step-q14 .hd-q14__file-input'));
      var results = [];

      inputs.forEach(function (input, i) {
        var compressed = hdQ14Compressed.get(input);
        if (compressed) {
          var b64 = compressed.dataURL.split(',')[1];
          results[i] = { name: compressed.name, type: compressed.type, data: b64 };
        } else {
          results[i] = null;
        }
      });

      callback(results.filter(Boolean));
    }

    // ── Done step: show thank you, then auto-close and reset after 5s ─────
    function showDoneAndAutoClose() {
      goToStep('done');
      setTimeout(function () {
        closeModal();
        resetForm();
      }, 5000);
    }

    // ── Main submit function ───────────────────────────────────────────────
    var hdSubmitting = false;

    function submitToSheets(triggerBtn) {
      if (hdSubmitting) return;
      hdSubmitting = true;

      // Collect all answers synchronously before navigating away
      var payload = {
        name:   hdUser.name,
        email:  hdUser.email,
        phone:  hdUser.mobile,
        age:    hdUser.age,
        gender: hdUser.sex,
        q1:  collectAnswer('q1'),
        q2:  collectAnswer('question'),
        q3:  collectAnswer('q3'),
        q4:  collectAnswer('q4'),
        q5:  collectAnswer('q5'),
        q6:  collectAnswer('q6'),
        q7:  collectAnswer('q7'),
        q8:  collectAnswer('q8'),
        q9:  collectAnswer('q9'),
        q10: collectAnswer('q10'),
        q11: collectAnswer('q11'),
        q12: collectAnswer('q12'),
        q13: collectAnswer('q13'),
        photos: []
      };

      // Show thank you immediately — don't wait for network
      showDoneAndAutoClose();

      // Submit in background after UI has updated
      if (!HD_SHEETS_URL || HD_SHEETS_URL.indexOf('PASTE_') === 0) return;

      readPhotosAsBase64(function (photos) {
        payload.photos = photos;
        fetch(HD_SHEETS_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify(payload)
        })
        .then(function () { hdSubmitting = false; })
        .catch(function (err) {
          hdSubmitting = false;
          console.warn('Hair Diagnosis: sheet submission failed —', err.message);
        });
      });
    }

    // Open — trigger on any [data-hd-modal-open]
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-hd-modal-open]')) openModal();
    });

    // All interactions inside modal via single delegated listener
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-hd-modal-close]')) {
        submitAndClose();
        return;
      }
      // Explicit step jump: data-hd-go-step="stepId"
      // Intercept "done" step to submit data first
      var goBtn = e.target.closest('[data-hd-go-step]');
      if (goBtn) {
        var targetStep = goBtn.getAttribute('data-hd-go-step');

        // Validate before navigating forward
        var validateStep = goBtn.getAttribute('data-hd-validate');
        if (validateStep === 'q1') {
          var q1Step = document.getElementById('hd-step-q1');
          var q1Error = document.getElementById('hd-q1-error');
          var hasSelection = q1Step && q1Step.querySelector('.hd-quest__img-tile[data-hd-tile].is-selected');
          if (!hasSelection) {
            if (q1Error) q1Error.style.display = 'block';
            return;
          }
          if (q1Error) q1Error.style.display = 'none';
        }
        if (validateStep === 'question') {
          var q2Step = document.getElementById('hd-step-question');
          var q2Error = document.getElementById('hd-q2-error');
          var hasQ2Selection = q2Step && q2Step.querySelector('.hd-quest__tile[data-hd-tile].is-selected');
          if (!hasQ2Selection) {
            if (q2Error) q2Error.style.display = 'block';
            return;
          }
          if (q2Error) q2Error.style.display = 'none';
        }
        if (validateStep === 'q3') {
          var q3Step = document.getElementById('hd-step-q3');
          var q3Error = document.getElementById('hd-q3-error');
          var hasPart1 = q3Step && q3Step.querySelector('[data-hd-radio].is-selected');
          var hasPart2 = q3Step && q3Step.querySelector('[data-hd-chip-single].is-selected');
          if (!hasPart1 || !hasPart2) {
            if (q3Error) q3Error.style.display = 'block';
            return;
          }
          if (q3Error) q3Error.style.display = 'none';
        }
        if (validateStep === 'q4') {
          var q4Step = document.getElementById('hd-step-q4');
          var q4Error = document.getElementById('hd-q4-error');
          var hasQ4 = q4Step && q4Step.querySelector('[data-hd-chip-single].is-selected');
          if (!hasQ4) {
            if (q4Error) q4Error.style.display = 'block';
            return;
          }
          if (q4Error) q4Error.style.display = 'none';
        }
        if (validateStep === 'q6') {
          var q6Step = document.getElementById('hd-step-q6');
          var q6Error = document.getElementById('hd-q6-error');
          var hasQ6 = q6Step && q6Step.querySelector('[data-hd-chip-single].is-selected');
          if (!hasQ6) {
            if (q6Error) q6Error.style.display = 'block';
            return;
          }
          if (q6Error) q6Error.style.display = 'none';
        }
        if (validateStep === 'q13') {
          var q13Step = document.getElementById('hd-step-q13');
          var q13Error = document.getElementById('hd-q13-error');
          var hasQ13 = q13Step && q13Step.querySelector('[data-hd-radio].is-selected');
          if (!hasQ13) {
            if (q13Error) q13Error.style.display = 'block';
            return;
          }
          if (q13Error) q13Error.style.display = 'none';
        }
        if (validateStep === 'q12') {
          var q12Step = document.getElementById('hd-step-q12');
          var q12Error = document.getElementById('hd-q12-error');
          var hasQ12 = q12Step && q12Step.querySelector('[data-hd-chip].is-selected');
          if (!hasQ12) {
            if (q12Error) q12Error.style.display = 'block';
            return;
          }
          if (q12Error) q12Error.style.display = 'none';
        }
        if (validateStep === 'q11') {
          var q11Step = document.getElementById('hd-step-q11');
          var q11Error = document.getElementById('hd-q11-error');
          var q11Groups = q11Step ? q11Step.querySelectorAll('[role="group"]') : [];
          var q11g1ok = q11Groups[0] && q11Groups[0].querySelector('[data-hd-chip-single].is-selected');
          var q11g2ok = q11Groups[1] && q11Groups[1].querySelector('[data-hd-chip].is-selected');
          if (!q11g1ok || !q11g2ok) {
            if (q11Error) q11Error.style.display = 'block';
            return;
          }
          if (q11Error) q11Error.style.display = 'none';
        }
        if (validateStep === 'q10') {
          var q10Step = document.getElementById('hd-step-q10');
          var q10Error = document.getElementById('hd-q10-error');
          var q10Groups = q10Step ? q10Step.querySelectorAll('[role="group"]') : [];
          var q10g1ok = q10Groups[0] && q10Groups[0].querySelector('[data-hd-chip].is-selected');
          var q10g2ok = q10Groups[1] && q10Groups[1].querySelector('[data-hd-chip-single].is-selected');
          if (!q10g1ok || !q10g2ok) {
            if (q10Error) q10Error.style.display = 'block';
            return;
          }
          if (q10Error) q10Error.style.display = 'none';
        }
        if (validateStep === 'q9') {
          var q9Step = document.getElementById('hd-step-q9');
          var q9Error = document.getElementById('hd-q9-error');
          var hasQ9 = q9Step && q9Step.querySelector('.hd-q9__tile[data-hd-tile].is-selected');
          if (!hasQ9) {
            if (q9Error) q9Error.style.display = 'block';
            return;
          }
          if (q9Error) q9Error.style.display = 'none';
        }
        if (validateStep === 'q8') {
          var q8Step = document.getElementById('hd-step-q8');
          var q8Error = document.getElementById('hd-q8-error');
          var q8Groups = q8Step ? q8Step.querySelectorAll('[role="group"]') : [];
          var q8g1ok = q8Groups[0] && q8Groups[0].querySelector('[data-hd-chip-single].is-selected');
          var q8g2ok = q8Groups[1] && q8Groups[1].querySelector('[data-hd-chip].is-selected');
          if (!q8g1ok || !q8g2ok) {
            if (q8Error) q8Error.style.display = 'block';
            return;
          }
          if (q8Error) q8Error.style.display = 'none';
        }
        if (validateStep === 'q7') {
          var q7Step = document.getElementById('hd-step-q7');
          var q7Error = document.getElementById('hd-q7-error');
          var hasQ7 = q7Step && q7Step.querySelector('[data-hd-chip-single].is-selected');
          if (!hasQ7) {
            if (q7Error) q7Error.style.display = 'block';
            return;
          }
          if (q7Error) q7Error.style.display = 'none';
        }
        if (validateStep === 'q5') {
          var q5Step = document.getElementById('hd-step-q5');
          var q5Error = document.getElementById('hd-q5-error');
          var q5Groups = q5Step ? q5Step.querySelectorAll('[role="group"]') : [];
          var g1ok = q5Groups[0] && q5Groups[0].querySelector('[data-hd-chip].is-selected');
          var g2ok = q5Groups[1] && q5Groups[1].querySelector('[data-hd-chip].is-selected');
          var g3ok = q5Groups[2] && q5Groups[2].querySelector('[data-hd-chip-single].is-selected');
          if (!g1ok || !g2ok || !g3ok) {
            if (q5Error) q5Error.style.display = 'block';
            return;
          }
          if (q5Error) q5Error.style.display = 'none';
        }

        if (validateStep === 'q14') {
          var q14Error = document.getElementById('hd-q14-error');
          var q14Valid = validateAllQ14Slots();
          if (!q14Valid) {
            if (q14Error) q14Error.style.display = 'block';
            return;
          }
          if (q14Error) q14Error.style.display = 'none';
        }

        if (targetStep === 'done') {
          submitToSheets(goBtn);
          return;
        }
        goToStep(targetStep);
        return;
      }
      // "Start the free test" on intro → userinfo
      if (e.target.closest('[data-hd-next-step]')) {
        goToStep('userinfo');
        return;
      }
      // Gender chip in userinfo step
      var genderBtn = e.target.closest('[data-hd-gender]');
      if (genderBtn) {
        document.querySelectorAll('#hd-step-userinfo .hd-userinfo__gender-btn').forEach(function (b) {
          b.classList.remove('is-selected', 'is-error');
        });
        genderBtn.classList.add('is-selected');
        hdUser.sex = genderBtn.getAttribute('data-hd-gender');
        document.getElementById('hd-ui-gender-err').textContent = '';
        return;
      }
      // Age chip in userinfo step
      var ageBtn = e.target.closest('[data-hd-age]');
      if (ageBtn && ageBtn.closest('#hd-step-userinfo')) {
        document.querySelectorAll('#hd-step-userinfo .hd-userinfo__age-btn').forEach(function (b) {
          b.classList.remove('is-selected', 'is-error');
        });
        ageBtn.classList.add('is-selected');
        var ageInput = document.getElementById('hd-ui-age');
        if (ageInput) ageInput.value = ageBtn.getAttribute('data-hd-age');
        document.getElementById('hd-ui-age-err').textContent = '';
        return;
      }
      // Userinfo Continue — validate then advance to Q1
      if (e.target.closest('[data-hd-userinfo-next]')) {
        if (validateUserInfo()) {
          goToStep('q1');
        }
        return;
      }
      // Tile selection
      // Q1 img-tiles = MULTI-select (toggle); all other tiles = single-select
      var tile = e.target.closest('[data-hd-tile]');
      if (tile) {
        var activeStep = modal.querySelector('.hd-modal__step[style*="flex"]');
        if (activeStep) {
          var isImgTile = tile.classList.contains('hd-quest__img-tile');
          if (isImgTile) {
            // Q1 — multi-select: just toggle this tile
            tile.classList.toggle('is-selected');
            // Clear Q1 validation error as soon as any tile is selected
            var q1Err = document.getElementById('hd-q1-error');
            if (q1Err) q1Err.style.display = 'none';
          } else {
            // Other steps — single-select
            activeStep.querySelectorAll('[data-hd-tile]').forEach(function (t) {
              t.classList.remove('is-selected');
            });
            tile.classList.add('is-selected');
            // Clear Q2/Q9 validation error as soon as a tile is selected
            var q2Err = document.getElementById('hd-q2-error');
            if (q2Err) q2Err.style.display = 'none';
            var q9Err = document.getElementById('hd-q9-error');
            if (q9Err) q9Err.style.display = 'none';
          }
        }
        return;
      }
      // Radio option — Q3 part 1 uses data-hd-radio but now MULTI-select (toggle)
      var radioBtn = e.target.closest('[data-hd-radio]');
      if (radioBtn) {
        radioBtn.classList.toggle('is-selected');
        var q3ErrR = document.getElementById('hd-q3-error');
        if (q3ErrR) q3ErrR.style.display = 'none';
        var q13ErrR = document.getElementById('hd-q13-error');
        if (q13ErrR) q13ErrR.style.display = 'none';
        return;
      }
      // Chip selection
      // data-hd-chip-single = single-select (Q3 part 2 "when did you notice")
      // data-hd-chip        = multi-select (all other chip groups)
      var singleChip = e.target.closest('[data-hd-chip-single]');
      if (singleChip) {
        var chipGroup = singleChip.closest('[role="group"]');
        if (chipGroup) {
          chipGroup.querySelectorAll('[data-hd-chip-single]').forEach(function (c) {
            c.classList.remove('is-selected');
          });
        }
        singleChip.classList.add('is-selected');
        var q3ErrC = document.getElementById('hd-q3-error');
        if (q3ErrC) q3ErrC.style.display = 'none';
        var q4ErrC = document.getElementById('hd-q4-error');
        if (q4ErrC) q4ErrC.style.display = 'none';
        var q5ErrC = document.getElementById('hd-q5-error');
        if (q5ErrC) q5ErrC.style.display = 'none';
        var q6ErrC = document.getElementById('hd-q6-error');
        if (q6ErrC) q6ErrC.style.display = 'none';
        var q7ErrC = document.getElementById('hd-q7-error');
        if (q7ErrC) q7ErrC.style.display = 'none';
        var q8ErrC = document.getElementById('hd-q8-error');
        if (q8ErrC) q8ErrC.style.display = 'none';
        var q10ErrC = document.getElementById('hd-q10-error');
        if (q10ErrC) q10ErrC.style.display = 'none';
        var q11ErrC = document.getElementById('hd-q11-error');
        if (q11ErrC) q11ErrC.style.display = 'none';
        return;
      }
      var chip = e.target.closest('[data-hd-chip]');
      if (chip) {
        chip.classList.toggle('is-selected');
        var chipGroup = chip.closest('[role="group"]');
        if (chipGroup) {
          var noneChip = Array.from(chipGroup.querySelectorAll('[data-hd-chip]')).find(function (c) {
            return c.textContent.trim() === 'None of these';
          });
          if (chip === noneChip && chip.classList.contains('is-selected')) {
            // "None of these" just selected — deselect all others
            chipGroup.querySelectorAll('[data-hd-chip]').forEach(function (c) {
              if (c !== noneChip) c.classList.remove('is-selected');
            });
          } else if (chip !== noneChip && chip.classList.contains('is-selected') && noneChip) {
            // Another option selected — deselect "None of these"
            noneChip.classList.remove('is-selected');
          }
        }
        var q5ErrChip = document.getElementById('hd-q5-error');
        if (q5ErrChip) q5ErrChip.style.display = 'none';
        var q8ErrChip = document.getElementById('hd-q8-error');
        if (q8ErrChip) q8ErrChip.style.display = 'none';
        var q10ErrChip = document.getElementById('hd-q10-error');
        if (q10ErrChip) q10ErrChip.style.display = 'none';
        var q11ErrChip = document.getElementById('hd-q11-error');
        if (q11ErrChip) q11ErrChip.style.display = 'none';
        var q12ErrChip = document.getElementById('hd-q12-error');
        if (q12ErrChip) q12ErrChip.style.display = 'none';
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) submitAndClose();
    });

    // Q14 constants
    var HD_Q14_MAX_INPUT_BYTES = 5 * 1024 * 1024; // 5 MB max per file
    var HD_Q14_TARGET_BYTES   = 100 * 1024;        // compress images down to ~100 KB
    var HD_Q14_MAX_PX         = 1600;               // max width or height after resize
    var HD_Q14_JPEG_QUALITY   = 0.82;               // JPEG output quality
    var HD_Q14_ALLOWED_TYPES  = ['image/jpeg', 'image/png', 'application/pdf', 'image/webp', 'image/heic', 'image/heif', 'image/gif', 'image/bmp', 'image/tiff'];
    var HD_Q14_ALLOWED_EXTS   = /\.(jpe?g|png|pdf|webp|heic|heif|gif|bmp|tiff?)$/i;
    var HD_Q14_IMAGE_TYPES    = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif', 'image/gif', 'image/bmp', 'image/tiff'];

    // Map from input element → compressed base64 dataURL (images) or original dataURL (PDFs)
    var hdQ14Compressed = new WeakMap();

    function q14SlotError(slot, msg) {
      var errEl = slot.querySelector('.hd-q14__slot-error');
      if (errEl) errEl.textContent = msg || '';
      if (msg) slot.classList.add('has-error');
      else slot.classList.remove('has-error');
    }

    function q14SlotStatus(slot, msg) {
      var errEl = slot.querySelector('.hd-q14__slot-error');
      if (errEl) { errEl.textContent = msg || ''; errEl.style.color = msg ? '#3d7a3a' : ''; }
    }

    function validateQ14FileType(file) {
      var ext = file.name.match(HD_Q14_ALLOWED_EXTS);
      if (!ext || HD_Q14_ALLOWED_TYPES.indexOf(file.type) === -1) {
        return 'Only JPG, PNG, PDF, WebP, HEIC, GIF, BMP or TIFF allowed.';
      }
      if (file.size > HD_Q14_MAX_INPUT_BYTES) {
        return 'File too large. Max 5 MB allowed.';
      }
      return null;
    }

    // Compress an image file to target bytes using canvas, returns a dataURL string via callback
    function compressImage(file, callback) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        var w = img.naturalWidth;
        var h = img.naturalHeight;

        // Scale down to HD_Q14_MAX_PX on the longest side
        if (w > HD_Q14_MAX_PX || h > HD_Q14_MAX_PX) {
          var ratio = Math.min(HD_Q14_MAX_PX / w, HD_Q14_MAX_PX / h);
          w = Math.round(w * ratio);
          h = Math.round(h * ratio);
        }

        var canvas = document.createElement('canvas');
        canvas.width  = w;
        canvas.height = h;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);

        // Try progressively lower quality until under target size
        var quality = HD_Q14_JPEG_QUALITY;
        var dataURL = canvas.toDataURL('image/jpeg', quality);
        var approxBytes = Math.round((dataURL.length - 22) * 0.75);

        var attempts = 0;
        while (approxBytes > HD_Q14_TARGET_BYTES && quality > 0.3 && attempts < 6) {
          quality = Math.max(0.3, quality - 0.1);
          dataURL = canvas.toDataURL('image/jpeg', quality);
          approxBytes = Math.round((dataURL.length - 22) * 0.75);
          attempts++;
        }

        callback(null, dataURL);
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        callback('Could not read image.');
      };
      img.src = url;
    }

    function validateAllQ14Slots() {
      var slots = Array.from(document.querySelectorAll('#hd-step-q14 .hd-q14__slot'));
      var valid = true;
      slots.forEach(function (slot) {
        var input = slot.querySelector('.hd-q14__file-input');
        if (!input) return;
        // Check compressed result is stored (means file was accepted & processed)
        if (!hdQ14Compressed.has(input)) {
          q14SlotError(slot, 'Photo required.');
          valid = false;
        }
      });
      return valid;
    }

    // Q14 photo: validate → compress → preview
    modal.addEventListener('change', function (e) {
      var input = e.target.closest('.hd-q14__file-input');
      if (!input || !input.files || !input.files[0]) return;
      var slot  = input.closest('.hd-q14__slot');
      var preview = slot.querySelector('[data-preview]');
      var file  = input.files[0];

      // Clear previous state
      hdQ14Compressed.delete(input);
      slot.classList.remove('has-photo', 'has-error');
      if (preview) preview.style.backgroundImage = '';

      // Type / raw size check
      var typeErr = validateQ14FileType(file);
      if (typeErr) {
        q14SlotError(slot, typeErr);
        input.value = '';
        return;
      }
      q14SlotError(slot, null);

      var isImage = HD_Q14_IMAGE_TYPES.indexOf(file.type) !== -1;

      if (isImage) {
        // Show compressing indicator
        q14SlotStatus(slot, 'Optimising…');
        slot.classList.add('is-compressing');

        compressImage(file, function (err, dataURL) {
          slot.classList.remove('is-compressing');
          if (err) {
            q14SlotError(slot, err);
            input.value = '';
            return;
          }
          var kb = Math.round((dataURL.length - 22) * 0.75 / 1024);
          q14SlotStatus(slot, 'Ready (' + kb + ' KB)');
          hdQ14Compressed.set(input, { name: file.name, type: 'image/jpeg', dataURL: dataURL });
          if (preview) preview.style.backgroundImage = 'url(' + dataURL + ')';
          slot.classList.add('has-photo');
        });
      } else {
        // PDF — read as-is, no compression
        var reader = new FileReader();
        reader.onload = function (ev) {
          hdQ14Compressed.set(input, { name: file.name, type: file.type, dataURL: ev.target.result });
          q14SlotStatus(slot, 'Ready (' + Math.round(file.size / 1024) + ' KB)');
          slot.classList.add('has-photo');
        };
        reader.readAsDataURL(file);
      }
    });
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hair-diagnosis-honest-expectations"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-honest]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.dataset.honest;
      var gender = btn.dataset.gender;
      var toggle = document.getElementById('hd-honest-toggle-' + id);

      if (toggle) toggle.classList.toggle('female-active', gender === 'female');

      document.querySelectorAll('[data-honest="' + id + '"]').forEach(function (t) {
        var active = t.dataset.gender === gender;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      ['male', 'female'].forEach(function (g) {
        var panel = document.getElementById('hd-honest-' + g + '-' + id);
        if (panel) panel.classList.toggle('is-active', g === gender);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hair-diagnosis-our-dietician"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[id^="hd-dietician-play-"]').forEach(function (btn) {
    var id = btn.id.replace('hd-dietician-play-', '');
    var video = document.getElementById('hd-dietician-video-' + id);
    if (!video) return;
    btn.addEventListener('click', function () {
      btn.classList.add('is-hidden');
      video.controls = true;
      video.play();
    });
    video.addEventListener('pause', function () {
      btn.classList.remove('is-hidden');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hair-diagnosis-real-stories"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStories(id) {
    var track = document.getElementById('hd-stories-track-' + id);
    var dots = document.querySelectorAll('.hd-stories__dot[data-stories="' + id + '"]');
    var navBtns = document.querySelectorAll('.hd-stories__nav-btn[data-stories="' + id + '"]');
    if (!track) return;
    var cards = track.querySelectorAll('.hd-stories__card');
    if (!cards.length) return;
    var current = 0;
    var total = cards.length;

    function getPerPage() {
      if (window.innerWidth <= 749) return 1;
      if (window.innerWidth <= 989) return 2;
      return 3;
    }

    function goTo(index) {
      var perPage = getPerPage();
      var maxIndex = Math.max(0, total - perPage);
      current = Math.min(Math.max(0, index), maxIndex);
      var outer = document.getElementById('hd-stories-outer-' + id);
      if (window.innerWidth <= 749 && outer) {
        var cardWidth = cards[0].offsetWidth + 14;
        outer.scrollTo({ left: current * cardWidth, behavior: 'smooth' });
      } else {
        var cardWidth = cards[0].offsetWidth + 20;
        track.style.transform = 'translateX(-' + (current * cardWidth) + 'px)';
      }
      dots.forEach(function (dot, i) {
        var active = i === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index));
      });
    });

    navBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(current + parseInt(btn.dataset.dir));
      });
    });

    var startX = 0;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (window.innerWidth <= 749) return; // native scroll handles mobile
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
    });
    // Sync dots to native scroll on mobile
    var outer2 = document.getElementById('hd-stories-outer-' + id);
    if (outer2) {
      outer2.addEventListener('scroll', function () {
        if (window.innerWidth > 749) return;
        var cardWidth = cards[0].offsetWidth + 14;
        var idx = Math.round(outer2.scrollLeft / cardWidth);
        if (idx !== current) {
          current = idx;
          dots.forEach(function (dot, i) {
            var active = i === current;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        }
      }, { passive: true });
    }

    window.addEventListener('resize', function () { goTo(current); });
  }

  document.querySelectorAll('[id^="hd-stories-track-"]').forEach(function (el) {
    initStories(el.id.replace('hd-stories-track-', ''));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hair-diagnosis-trusted-customers"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grids = document.querySelectorAll('[id^="hd-trusted-grid-"]');
  grids.forEach(function (grid) {
    var id = grid.id.replace('hd-trusted-grid-', '');
    var prevBtn = document.getElementById('hd-trusted-prev-' + id);
    var nextBtn = document.getElementById('hd-trusted-next-' + id);
    var dotsContainer = document.getElementById('hd-trusted-dots-' + id);
    if (!prevBtn || !nextBtn || !dotsContainer) return;

    var cards = Array.from(grid.querySelectorAll('.hd-trusted__card-tilt'));
    var dots = Array.from(dotsContainer.querySelectorAll('.hd-trusted__dot'));
    var current = 0;

    function isMobile() {
      return window.innerWidth <= 749;
    }

    function goTo(index) {
      var count = cards.length;
      current = (index + count) % count;
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
      if (isMobile()) {
        var card = cards[current];
        grid.scrollTo({ left: card.offsetLeft - 24, behavior: 'smooth' });
      }
    }

    prevBtn.addEventListener('click', function () { goTo(current - 1); });
    nextBtn.addEventListener('click', function () { goTo(current + 1); });

    /* Sync dots on mobile scroll */
    grid.addEventListener('scroll', function () {
      if (!isMobile()) return;
      var scrollLeft = grid.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.offsetLeft - 24 - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      if (closest !== current) {
        current = closest;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Also bail if ANY predictive-search is open (covers both desktop & mobile)
      const anySearchOpen = document.querySelector('predictive-search[open]');
      if (anySearchOpen) return;

      // Also bail if the mobile search modal is active
      if (document.querySelector('.header__desktop__bar__r.mobile.search-modal-active')) return;

      // Also bail if body scroll is locked by search
      if (document.body.classList.contains('overflow-hidden')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
